import React from 'react';
import { Heart, Instagram, Linkedin, Mail, Sparkles } from 'lucide-react';

// TikTok SVG icon component
const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const Footer = ({ bioData }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-burgundy via-bordeaux to-burgundy text-white py-16 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-teal/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-pink/10 rounded-full blur-3xl"></div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="grid md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-playfair font-bold mb-2 flex items-center gap-2">
              <Sparkles className="w-6 h-6" />
              {bioData.name}
            </h3>
            <p className="text-white/90 text-base mb-1">
              {bioData.stageName}
            </p>
            <p className="text-white/80 text-sm italic mb-4">
              {bioData.tagline}
            </p>
            <p className="text-white/70 text-sm leading-relaxed">
              London-based comedian bringing laughter in English and Italian
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-lg">Quick Links</h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a href="#about" className="text-white/80 hover:text-white transition-colors hover:translate-x-1 inline-block">
                  → About
                </a>
              </li>
              <li>
                <a href="#gallery" className="text-white/80 hover:text-white transition-colors hover:translate-x-1 inline-block">
                  → Gallery
                </a>
              </li>
              <li>
                <a href="#shows" className="text-white/80 hover:text-white transition-colors hover:translate-x-1 inline-block">
                  → Upcoming Shows
                </a>
              </li>
              <li>
                <a href="#videos" className="text-white/80 hover:text-white transition-colors hover:translate-x-1 inline-block">
                  → Comedy Clips
                </a>
              </li>
              <li>
                <a href="#services" className="text-white/80 hover:text-white transition-colors hover:translate-x-1 inline-block">
                  → Services
                </a>
              </li>
              <li>
                <a href="#contact" className="text-white/80 hover:text-white transition-colors hover:translate-x-1 inline-block">
                  → Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-semibold mb-4 text-lg">Connect With Me</h4>
            <div className="flex gap-3 mb-4">
              <a
                href={bioData.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 backdrop-blur-sm border border-white/20"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href={bioData.tiktokUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 backdrop-blur-sm border border-white/20"
                aria-label="TikTok"
              >
                <TikTokIcon className="w-5 h-5" />
              </a>
              <a
                href={bioData.linkedInUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 backdrop-blur-sm border border-white/20"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="#contact"
                className="w-11 h-11 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 backdrop-blur-sm border border-white/20"
                aria-label="Contact"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              Follow for the latest comedy clips, show updates, and behind-the-scenes content
            </p>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/20 pt-8 text-center text-sm text-white/70">
          <p className="flex items-center justify-center gap-2 flex-wrap">
            <span>© {currentYear} Funny Is My Surname.</span>
            <span className="hidden sm:inline">•</span>
            <span className="flex items-center gap-1">
              Made with <Heart className="w-4 h-4 text-pink fill-pink animate-pulse" /> in London
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
